import Input from './src/input.vue';

Input.install = function() {
    Vue.component(Input.name, Input);
};

export default Input;


// WEBPACK FOOTER //
// ./src/components/input/index.js